<template>
  <div class="mt-8">
    <px-dashboard-acessos-header @change="onChangeDate"/>
    <div v-if="!loading && selectedDate">
      <div>
        <v-row>
          <v-col cols="12" sm="6">
            <px-dashboard-acessos-acessos-dia :state-date="selectedDate"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-dashboard-acessos-acesso-fornecedor-dia :state-date="selectedDate"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <px-dashboard-acessos-usuarios-unicos-dia :state-date="selectedDate"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-dashboard-acessos-acessos-categoria :state-date="selectedDate"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="7">
            <px-dashboard-acessos-listagem-ofertas :data-mes="selectedDate"/>
          </v-col>
          <v-col cols="12" sm="5">
            <px-dashboard-acessos-total-acessos :state-date="selectedDate"/>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardAcessosHeader from './DashboardAcessosHeader.vue';
import DashboardAcessosAcessosDia from './DashboardAcessosAcessosDia.vue';
import DashboardAcessosAcessoFornecedorDia from './DashboardAcessosAcessoFornecedorDia.vue';
import DashboardAcessosListagemOfertas from './ofertas-acessadas/DashboardAcessosListagemOfertas.vue';
import DashboardAcessosAcessosCategoria from './DashboardAcessosAcessosCategoria.vue';
import DashboardAcessosUsuariosUnicosDia from './DashboardAcessosUsuariosUnicosDia.vue';
import DashboardAcessosTotalAcessos from './DashboardAcessosTotalAcessos.vue';

export default {
  data() {
    return {
      loading: false,
      selectedDate: null,
    };
  },
  methods: {
    onChangeDate(dateState) {
      this.selectedDate = dateState;
    },
  },
  components: {
    pxDashboardAcessosHeader: DashboardAcessosHeader,
    pxDashboardAcessosAcessosDia: DashboardAcessosAcessosDia,
    pxDashboardAcessosAcessoFornecedorDia: DashboardAcessosAcessoFornecedorDia,
    pxDashboardAcessosListagemOfertas: DashboardAcessosListagemOfertas,
    pxDashboardAcessosAcessosCategoria: DashboardAcessosAcessosCategoria,
    pxDashboardAcessosUsuariosUnicosDia: DashboardAcessosUsuariosUnicosDia,
    pxDashboardAcessosTotalAcessos: DashboardAcessosTotalAcessos,
  },
};
</script>
